import { render, staticRenderFns } from "./Prayers.vue?vue&type=template&id=ba69a85c&"
import script from "./Prayers.vue?vue&type=script&lang=js&"
export * from "./Prayers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports